import { createFileRoute } from '@tanstack/react-router';
import { ClientsPage } from '../clients-page';
import { ExistingClientsCard } from '../firm/existing-clients-card';
import { FeatureGate } from '../firm/feature-gate';
import { TableSearch } from '../table-search';

export const Route = createFileRoute('/clients/existing')({
  // The table keeps its view in the address.
  validateSearch: TableSearch,
  component: ExistingClients,
});

/** What Kanos does not hold of the firm's existing clients yet (ADR-080 § 4), with CHECK-POINT. */
function ExistingClients() {
  return (
    <ClientsPage>
      <FeatureGate feature="check-point">
        <ExistingClientsCard />
      </FeatureGate>
    </ClientsPage>
  );
}
